import { Component, input, output } from '@angular/core';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import {
  ButtonComponent,
  DEFAULT_MAX_FILE_SIZE,
  DEFAULT_VALID_IMAGE_MIME_TYPES,
  IconComponent,
  TruncateComponent,
} from '@core/user-interface-legacy';
import { getHumanReadableFileSize } from '@core/utils-legacy';

@Component({
  selector: 'tlc-avatar-input',
  imports: [ButtonComponent, IconComponent, TruncateComponent, TranslatePipe],
  templateUrl: './avatar-input.component.html',
  styleUrl: './avatar-input.component.less',
})
export class AvatarInputComponent {
  protected readonly DEFAULT_VALID_IMAGE_MIME_TYPES = DEFAULT_VALID_IMAGE_MIME_TYPES;

  public errorMessage: string | undefined;
  public avatarFile: File | null;

  public maxFileSize = input(DEFAULT_MAX_FILE_SIZE); // file size limit in bytes
  public avatarChanged = output<File | null>();

  constructor(private i18n: I18nService) {}

  public cacheAvatarImg(files: FileList | null): void {
    const file = files ? files[0] : undefined;
    this.errorMessage = undefined;
    if (!file) return;

    const validType = DEFAULT_VALID_IMAGE_MIME_TYPES.includes(file.type);
    const validSize = file.size <= this.maxFileSize();

    if (validType && validSize) {
      this.avatarFile = file;
      this.avatarChanged.emit(file);
    } else {
      this.avatarFile = null;
      this.avatarChanged.emit(null);
      if (!validSize)
        this.errorMessage = this.i18n.translate('tlc.common.errors.image_validation.size', {
          limit: getHumanReadableFileSize(this.maxFileSize()),
          fileSize: getHumanReadableFileSize(file.size),
        });
      if (!validType)
        this.errorMessage = this.i18n.translate('tlc.common.errors.image_validation.type');
    }
  }
}
